import { GraphQLResolveInfo } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Balance = {
  __typename?: 'Balance';
  credit: Scalars['String']['output'];
  mint: Scalars['String']['output'];
  mintId: Scalars['Int']['output'];
};

export enum Decision {
  Approved = 'Approved',
  Pending = 'Pending',
  Redirected = 'Redirected',
  Rejected = 'Rejected'
}

export type Mint = {
  __typename?: 'Mint';
  chain: Scalars['String']['output'];
  decimals: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  img?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createSwapRequest: Swap;
  logout: Scalars['Boolean']['output'];
  requestTwoFactorAuth: Scalars['String']['output'];
  resetMyPassword: User;
  setupTwoFactorAuth: User;
  updateEmail: User;
  updatePassword: User;
  updateUsername: User;
};


export type MutationCreateSwapRequestArgs = {
  swapRequest: SwapRequest;
};


export type MutationSetupTwoFactorAuthArgs = {
  secret: Scalars['String']['input'];
};


export type MutationUpdateEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdatePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationUpdateUsernameArgs = {
  username: Scalars['String']['input'];
};

export type Organization = {
  __typename?: 'Organization';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permission: Role;
};

export type OrganizationWithPendingSwaps = {
  __typename?: 'OrganizationWithPendingSwaps';
  hasPendingSwaps: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permission: Role;
};

export type Query = {
  __typename?: 'Query';
  getBalance: Array<Balance>;
  getOrganizations: Array<OrganizationWithPendingSwaps>;
  getPriceQuote: Quote;
  getSupportedMints: Array<Mint>;
  getSwap: Swap;
  getSwaps: Array<Swap>;
  getTopupHistory: Array<Topup>;
  getTransientTopups: Array<Topup>;
  getUser: User;
  getWallets: Array<Wallet>;
  getWhitelist: Array<Whitelist>;
};


export type QueryGetBalanceArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetPriceQuoteArgs = {
  fromAmount?: InputMaybe<Scalars['String']['input']>;
  fromMintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  toMintId: Scalars['Int']['input'];
};


export type QueryGetSwapArgs = {
  swapId: Scalars['String']['input'];
};


export type QueryGetSwapsArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
};


export type QueryGetTopupHistoryArgs = {
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
};


export type QueryGetTransientTopupsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetWalletsArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryGetWhitelistArgs = {
  organizationId: Scalars['String']['input'];
};

export type Quote = {
  __typename?: 'Quote';
  expiresAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  toAmount: Scalars['String']['output'];
};

export enum Role {
  Swap = 'Swap',
  View = 'View'
}

export type Swap = {
  __typename?: 'Swap';
  date: Scalars['String']['output'];
  endAddress: Scalars['String']['output'];
  fromAmount: Scalars['String']['output'];
  fromMint: Mint;
  id: Scalars['String']['output'];
  status: SwapStatus;
  steps: Array<SwapStep>;
  toAmount?: Maybe<Scalars['String']['output']>;
  toMint: Mint;
  txHash?: Maybe<Scalars['String']['output']>;
};

export type SwapRequest = {
  endAddress: Scalars['Int']['input'];
  fromAmount?: InputMaybe<Scalars['String']['input']>;
  fromMintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  toMintId: Scalars['Int']['input'];
};

export enum SwapStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Pending = 'Pending'
}

export type SwapStep = {
  __typename?: 'SwapStep';
  action: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isPending: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
};

export type Topup = {
  __typename?: 'Topup';
  amount: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  decision: Decision;
  decisionAt?: Maybe<Scalars['String']['output']>;
  finalizedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  mint: Mint;
  txHash: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  has2fa: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type UserLog = {
  __typename?: 'UserLog';
  action: Scalars['String']['output'];
  date: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  username: Scalars['String']['output'];
};

export type Wallet = {
  __typename?: 'Wallet';
  address: Scalars['String']['output'];
  chain: Scalars['String']['output'];
};

export type Whitelist = {
  __typename?: 'Whitelist';
  address: Scalars['String']['output'];
  chain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', getUser: { __typename?: 'User', username: string, email: string, has2fa: boolean } };

export type GetBalanceQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetBalanceQuery = { __typename?: 'Query', getBalance: Array<{ __typename?: 'Balance', credit: string, mint: string, mintId: number }> };

export type GetWalletsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetWalletsQuery = { __typename?: 'Query', getWallets: Array<{ __typename?: 'Wallet', chain: string, address: string }> };

export type GetSupportedMintsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSupportedMintsQuery = { __typename?: 'Query', getSupportedMints: Array<{ __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, symbol: string, decimals: number }> };

export type GetTransientTopupsQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetTransientTopupsQuery = { __typename?: 'Query', getTransientTopups: Array<{ __typename?: 'Topup', id: string, amount: string, txHash: string, createdAt: string, decisionAt?: string | null, decision: Decision, finalizedAt?: string | null, mint: { __typename?: 'Mint', id: number } }> };

export type GetTopupHistoryQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;


export type GetTopupHistoryQuery = { __typename?: 'Query', getTopupHistory: Array<{ __typename?: 'Topup', id: string, amount: string, txHash: string, createdAt: string, decisionAt?: string | null, decision: Decision, finalizedAt?: string | null, mint: { __typename?: 'Mint', id: number, chain: string } }> };

export type GetSwapsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSwapsQuery = { __typename?: 'Query', getSwaps: Array<{ __typename?: 'Swap', id: string, fromAmount: string, toAmount?: string | null, txHash?: string | null, endAddress: string, status: SwapStatus, date: string, fromMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, symbol: string, decimals: number }, toMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, symbol: string, decimals: number }, steps: Array<{ __typename?: 'SwapStep', id: number, action: string, date: string, status: string, isPending: boolean }> }> };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'OrganizationWithPendingSwaps', id: string, name: string, permission: Role, hasPendingSwaps: boolean }> };

export type GetSwapQueryVariables = Exact<{
  swapId: Scalars['String']['input'];
}>;


export type GetSwapQuery = { __typename?: 'Query', getSwap: { __typename?: 'Swap', id: string, fromAmount: string, toAmount?: string | null, txHash?: string | null, endAddress: string, status: SwapStatus, date: string, fromMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null }, toMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null }, steps: Array<{ __typename?: 'SwapStep', id: number, action: string, date: string, status: string, isPending: boolean }> } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type UpdateUsernameMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type UpdateUsernameMutation = { __typename?: 'Mutation', updateUsername: { __typename?: 'User', userId: string, username: string, email: string } };

export type UpdateEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail: { __typename?: 'User', userId: string, username: string, email: string } };

export type UpdatePasswordMutationVariables = Exact<{
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'User', userId: string, username: string, email: string } };

export type ResetMyPasswordMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetMyPasswordMutation = { __typename?: 'Mutation', resetMyPassword: { __typename?: 'User', userId: string, username: string, email: string } };

export type RequestTwoFactorAuthMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestTwoFactorAuthMutation = { __typename?: 'Mutation', requestTwoFactorAuth: string };

export type SetupTwoFactorAuthMutationVariables = Exact<{
  secret: Scalars['String']['input'];
}>;


export type SetupTwoFactorAuthMutation = { __typename?: 'Mutation', setupTwoFactorAuth: { __typename?: 'User', userId: string, username: string, email: string } };

export type CreateSwapRequestMutationVariables = Exact<{
  swapRequest: SwapRequest;
}>;


export type CreateSwapRequestMutation = { __typename?: 'Mutation', createSwapRequest: { __typename?: 'Swap', id: string, fromAmount: string, toAmount?: string | null, txHash?: string | null, endAddress: string, status: SwapStatus, date: string, fromMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, symbol: string, decimals: number }, toMint: { __typename?: 'Mint', id: number, name: string, chain: string, img?: string | null, symbol: string, decimals: number } } };

export type GetPriceQuoteQueryVariables = Exact<{
  fromMintId: Scalars['Int']['input'];
  toMintId: Scalars['Int']['input'];
  organizationId: Scalars['String']['input'];
  fromAmount?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPriceQuoteQuery = { __typename?: 'Query', getPriceQuote: { __typename?: 'Quote', id: string, expiresAt: string, toAmount: string } };

export type GetWhitelistQueryVariables = Exact<{
  organizationId: Scalars['String']['input'];
}>;


export type GetWhitelistQuery = { __typename?: 'Query', getWhitelist: Array<{ __typename?: 'Whitelist', id: number, chain: string, address: string, name: string }> };


export const GetUserDocument = gql`
    query getUser {
  getUser {
    username
    email
    has2fa
  }
}
    `;

export function useGetUserQuery(options?: Omit<Urql.UseQueryArgs<GetUserQueryVariables>, 'query'>) {
  return Urql.useQuery<GetUserQuery, GetUserQueryVariables>({ query: GetUserDocument, ...options });
};
export const GetBalanceDocument = gql`
    query getBalance($organizationId: String!) {
  getBalance(organizationId: $organizationId) {
    credit
    mint
    mintId
  }
}
    `;

export function useGetBalanceQuery(options: Omit<Urql.UseQueryArgs<GetBalanceQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBalanceQuery, GetBalanceQueryVariables>({ query: GetBalanceDocument, ...options });
};
export const GetWalletsDocument = gql`
    query getWallets($organizationId: String!) {
  getWallets(organizationId: $organizationId) {
    chain
    address
  }
}
    `;

export function useGetWalletsQuery(options: Omit<Urql.UseQueryArgs<GetWalletsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWalletsQuery, GetWalletsQueryVariables>({ query: GetWalletsDocument, ...options });
};
export const GetSupportedMintsDocument = gql`
    query getSupportedMints {
  getSupportedMints {
    id
    name
    chain
    img
    symbol
    decimals
  }
}
    `;

export function useGetSupportedMintsQuery(options?: Omit<Urql.UseQueryArgs<GetSupportedMintsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSupportedMintsQuery, GetSupportedMintsQueryVariables>({ query: GetSupportedMintsDocument, ...options });
};
export const GetTransientTopupsDocument = gql`
    query getTransientTopups($organizationId: String!) {
  getTransientTopups(organizationId: $organizationId) {
    id
    amount
    mint {
      id
    }
    txHash
    createdAt
    decisionAt
    decision
    finalizedAt
  }
}
    `;

export function useGetTransientTopupsQuery(options: Omit<Urql.UseQueryArgs<GetTransientTopupsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTransientTopupsQuery, GetTransientTopupsQueryVariables>({ query: GetTransientTopupsDocument, ...options });
};
export const GetTopupHistoryDocument = gql`
    query getTopupHistory($organizationId: String!, $page: Int!) {
  getTopupHistory(organizationId: $organizationId, page: $page) {
    id
    amount
    mint {
      id
      chain
    }
    txHash
    createdAt
    decisionAt
    decision
    finalizedAt
  }
}
    `;

export function useGetTopupHistoryQuery(options: Omit<Urql.UseQueryArgs<GetTopupHistoryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTopupHistoryQuery, GetTopupHistoryQueryVariables>({ query: GetTopupHistoryDocument, ...options });
};
export const GetSwapsDocument = gql`
    query getSwaps($page: Int!, $organizationId: String) {
  getSwaps(page: $page, organizationId: $organizationId) {
    id
    fromMint {
      id
      name
      chain
      img
      symbol
      decimals
    }
    toMint {
      id
      name
      chain
      img
      symbol
      decimals
    }
    fromAmount
    toAmount
    txHash
    endAddress
    status
    date
    steps {
      id
      action
      date
      status
      isPending
    }
  }
}
    `;

export function useGetSwapsQuery(options: Omit<Urql.UseQueryArgs<GetSwapsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSwapsQuery, GetSwapsQueryVariables>({ query: GetSwapsDocument, ...options });
};
export const GetOrganizationsDocument = gql`
    query getOrganizations {
  getOrganizations {
    id
    name
    permission
    hasPendingSwaps
  }
}
    `;

export function useGetOrganizationsQuery(options?: Omit<Urql.UseQueryArgs<GetOrganizationsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>({ query: GetOrganizationsDocument, ...options });
};
export const GetSwapDocument = gql`
    query getSwap($swapId: String!) {
  getSwap(swapId: $swapId) {
    id
    fromMint {
      id
      name
      chain
      img
    }
    toMint {
      id
      name
      chain
      img
    }
    fromAmount
    toAmount
    txHash
    endAddress
    status
    date
    steps {
      id
      action
      date
      status
      isPending
    }
  }
}
    `;

export function useGetSwapQuery(options: Omit<Urql.UseQueryArgs<GetSwapQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSwapQuery, GetSwapQueryVariables>({ query: GetSwapDocument, ...options });
};
export const LogoutDocument = gql`
    mutation logout {
  logout
}
    `;

export function useLogoutMutation() {
  return Urql.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument);
};
export const UpdateUsernameDocument = gql`
    mutation updateUsername($username: String!) {
  updateUsername(username: $username) {
    userId
    username
    email
  }
}
    `;

export function useUpdateUsernameMutation() {
  return Urql.useMutation<UpdateUsernameMutation, UpdateUsernameMutationVariables>(UpdateUsernameDocument);
};
export const UpdateEmailDocument = gql`
    mutation updateEmail($email: String!) {
  updateEmail(email: $email) {
    userId
    username
    email
  }
}
    `;

export function useUpdateEmailMutation() {
  return Urql.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument);
};
export const UpdatePasswordDocument = gql`
    mutation updatePassword($oldPassword: String!, $newPassword: String!) {
  updatePassword(oldPassword: $oldPassword, newPassword: $newPassword) {
    userId
    username
    email
  }
}
    `;

export function useUpdatePasswordMutation() {
  return Urql.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument);
};
export const ResetMyPasswordDocument = gql`
    mutation resetMyPassword {
  resetMyPassword {
    userId
    username
    email
  }
}
    `;

export function useResetMyPasswordMutation() {
  return Urql.useMutation<ResetMyPasswordMutation, ResetMyPasswordMutationVariables>(ResetMyPasswordDocument);
};
export const RequestTwoFactorAuthDocument = gql`
    mutation requestTwoFactorAuth {
  requestTwoFactorAuth
}
    `;

export function useRequestTwoFactorAuthMutation() {
  return Urql.useMutation<RequestTwoFactorAuthMutation, RequestTwoFactorAuthMutationVariables>(RequestTwoFactorAuthDocument);
};
export const SetupTwoFactorAuthDocument = gql`
    mutation setupTwoFactorAuth($secret: String!) {
  setupTwoFactorAuth(secret: $secret) {
    userId
    username
    email
  }
}
    `;

export function useSetupTwoFactorAuthMutation() {
  return Urql.useMutation<SetupTwoFactorAuthMutation, SetupTwoFactorAuthMutationVariables>(SetupTwoFactorAuthDocument);
};
export const CreateSwapRequestDocument = gql`
    mutation createSwapRequest($swapRequest: SwapRequest!) {
  createSwapRequest(swapRequest: $swapRequest) {
    id
    fromMint {
      id
      name
      chain
      img
      symbol
      decimals
    }
    toMint {
      id
      name
      chain
      img
      symbol
      decimals
    }
    fromAmount
    toAmount
    txHash
    endAddress
    status
    date
  }
}
    `;

export function useCreateSwapRequestMutation() {
  return Urql.useMutation<CreateSwapRequestMutation, CreateSwapRequestMutationVariables>(CreateSwapRequestDocument);
};
export const GetPriceQuoteDocument = gql`
    query getPriceQuote($fromMintId: Int!, $toMintId: Int!, $organizationId: String!, $fromAmount: String) {
  getPriceQuote(
    fromMintId: $fromMintId
    toMintId: $toMintId
    organizationId: $organizationId
    fromAmount: $fromAmount
  ) {
    id
    expiresAt
    toAmount
  }
}
    `;

export function useGetPriceQuoteQuery(options: Omit<Urql.UseQueryArgs<GetPriceQuoteQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPriceQuoteQuery, GetPriceQuoteQueryVariables>({ query: GetPriceQuoteDocument, ...options });
};
export const GetWhitelistDocument = gql`
    query getWhitelist($organizationId: String!) {
  getWhitelist(organizationId: $organizationId) {
    id
    chain
    address
    name
  }
}
    `;

export function useGetWhitelistQuery(options: Omit<Urql.UseQueryArgs<GetWhitelistQueryVariables>, 'query'>) {
  return Urql.useQuery<GetWhitelistQuery, GetWhitelistQueryVariables>({ query: GetWhitelistDocument, ...options });
};


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Balance: ResolverTypeWrapper<Balance>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Decision: Decision;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Mint: ResolverTypeWrapper<Mint>;
  Mutation: ResolverTypeWrapper<{}>;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationWithPendingSwaps: ResolverTypeWrapper<OrganizationWithPendingSwaps>;
  Query: ResolverTypeWrapper<{}>;
  Quote: ResolverTypeWrapper<Quote>;
  Role: Role;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Swap: ResolverTypeWrapper<Swap>;
  SwapRequest: SwapRequest;
  SwapStatus: SwapStatus;
  SwapStep: ResolverTypeWrapper<SwapStep>;
  Topup: ResolverTypeWrapper<Topup>;
  User: ResolverTypeWrapper<User>;
  UserLog: ResolverTypeWrapper<UserLog>;
  Wallet: ResolverTypeWrapper<Wallet>;
  Whitelist: ResolverTypeWrapper<Whitelist>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Balance: Balance;
  Boolean: Scalars['Boolean']['output'];
  Int: Scalars['Int']['output'];
  Mint: Mint;
  Mutation: {};
  Organization: Organization;
  OrganizationWithPendingSwaps: OrganizationWithPendingSwaps;
  Query: {};
  Quote: Quote;
  String: Scalars['String']['output'];
  Swap: Swap;
  SwapRequest: SwapRequest;
  SwapStep: SwapStep;
  Topup: Topup;
  User: User;
  UserLog: UserLog;
  Wallet: Wallet;
  Whitelist: Whitelist;
};

export type BalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Balance'] = ResolversParentTypes['Balance']> = {
  credit?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mintId?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MintResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mint'] = ResolversParentTypes['Mint']> = {
  chain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  decimals?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  img?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  createSwapRequest?: Resolver<ResolversTypes['Swap'], ParentType, ContextType, RequireFields<MutationCreateSwapRequestArgs, 'swapRequest'>>;
  logout?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requestTwoFactorAuth?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resetMyPassword?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  setupTwoFactorAuth?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationSetupTwoFactorAuthArgs, 'secret'>>;
  updateEmail?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateEmailArgs, 'email'>>;
  updatePassword?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdatePasswordArgs, 'newPassword' | 'oldPassword'>>;
  updateUsername?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<MutationUpdateUsernameArgs, 'username'>>;
};

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permission?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationWithPendingSwapsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationWithPendingSwaps'] = ResolversParentTypes['OrganizationWithPendingSwaps']> = {
  hasPendingSwaps?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  permission?: Resolver<ResolversTypes['Role'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  getBalance?: Resolver<Array<ResolversTypes['Balance']>, ParentType, ContextType, RequireFields<QueryGetBalanceArgs, 'organizationId'>>;
  getOrganizations?: Resolver<Array<ResolversTypes['OrganizationWithPendingSwaps']>, ParentType, ContextType>;
  getPriceQuote?: Resolver<ResolversTypes['Quote'], ParentType, ContextType, RequireFields<QueryGetPriceQuoteArgs, 'fromMintId' | 'organizationId' | 'toMintId'>>;
  getSupportedMints?: Resolver<Array<ResolversTypes['Mint']>, ParentType, ContextType>;
  getSwap?: Resolver<ResolversTypes['Swap'], ParentType, ContextType, RequireFields<QueryGetSwapArgs, 'swapId'>>;
  getSwaps?: Resolver<Array<ResolversTypes['Swap']>, ParentType, ContextType, RequireFields<QueryGetSwapsArgs, 'page'>>;
  getTopupHistory?: Resolver<Array<ResolversTypes['Topup']>, ParentType, ContextType, RequireFields<QueryGetTopupHistoryArgs, 'organizationId' | 'page'>>;
  getTransientTopups?: Resolver<Array<ResolversTypes['Topup']>, ParentType, ContextType, RequireFields<QueryGetTransientTopupsArgs, 'organizationId'>>;
  getUser?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  getWallets?: Resolver<Array<ResolversTypes['Wallet']>, ParentType, ContextType, RequireFields<QueryGetWalletsArgs, 'organizationId'>>;
  getWhitelist?: Resolver<Array<ResolversTypes['Whitelist']>, ParentType, ContextType, RequireFields<QueryGetWhitelistArgs, 'organizationId'>>;
};

export type QuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Quote'] = ResolversParentTypes['Quote']> = {
  expiresAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwapResolvers<ContextType = any, ParentType extends ResolversParentTypes['Swap'] = ResolversParentTypes['Swap']> = {
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromAmount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromMint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SwapStatus'], ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['SwapStep']>, ParentType, ContextType>;
  toAmount?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  toMint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  txHash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwapStepResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwapStep'] = ResolversParentTypes['SwapStep']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  isPending?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TopupResolvers<ContextType = any, ParentType extends ResolversParentTypes['Topup'] = ResolversParentTypes['Topup']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  decision?: Resolver<ResolversTypes['Decision'], ParentType, ContextType>;
  decisionAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  finalizedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  mint?: Resolver<ResolversTypes['Mint'], ParentType, ContextType>;
  txHash?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  has2fa?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserLog'] = ResolversParentTypes['UserLog']> = {
  action?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WalletResolvers<ContextType = any, ParentType extends ResolversParentTypes['Wallet'] = ResolversParentTypes['Wallet']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type WhitelistResolvers<ContextType = any, ParentType extends ResolversParentTypes['Whitelist'] = ResolversParentTypes['Whitelist']> = {
  address?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chain?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Balance?: BalanceResolvers<ContextType>;
  Mint?: MintResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationWithPendingSwaps?: OrganizationWithPendingSwapsResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Quote?: QuoteResolvers<ContextType>;
  Swap?: SwapResolvers<ContextType>;
  SwapStep?: SwapStepResolvers<ContextType>;
  Topup?: TopupResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserLog?: UserLogResolvers<ContextType>;
  Wallet?: WalletResolvers<ContextType>;
  Whitelist?: WhitelistResolvers<ContextType>;
};

